import { useState } from "react";
import "styles/style.scss";
import { Routes, Route } from "react-router-dom";
import IndexPage from "layout/IndexPage";
import LetterPage from "layout/LetterPage";
import SentPage from "layout/SentPage";
import { userContext } from "contextProviders/userContext";
function App() {
  const [user, setUser] = useState(null);

  return (
    <userContext.Provider value={{ user, setUser }}>
      <Routes>
        <Route path="/" element={<IndexPage />} />
        <Route path="/letter" element={<LetterPage />} />
        <Route path="/sent" element={<SentPage />} />
      </Routes>
    </userContext.Provider>
  );
}

export default App;
